/**
 * @generated SignedSource<<944ea0fb2b2cee31531074942f0d33b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CopilotSettingsUserFilter$data = {
  readonly email: string;
  readonly fullName: string;
  readonly id: string;
  readonly image: string;
  readonly isGuest: boolean;
  readonly " $fragmentType": "CopilotSettingsUserFilter";
};
export type CopilotSettingsUserFilter$key = {
  readonly " $data"?: CopilotSettingsUserFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"CopilotSettingsUserFilter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CopilotSettingsUserFilter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e412c679c5bfbb2a8ed8b68c745feec5";

export default node;
